<template>
    <div>
        Default!
    </div>
</template>
<script>

    export default {
        data: function () {
            return {
            }
        },
        mounted: function () {
            this.getToken()
        },
        methods: {
            getToken() {
                let grabToken = async() => {
                    // await Promise.resolve(this.storeToken());
                }
                
                grabToken()
                .then(() => {
                    return "done";
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>